import type {Result, UseCase} from 'framework';
import type {LineIngredientCandidate} from '../../domain/line-ingredient-candidate';
import type {SavedMealError} from '../../domain/errors';
import type {SavedMealRepository, SearchLineIngredientsInput} from '../ports/saved-meal.repository';

export class SearchLineIngredients implements UseCase<
  [SearchLineIngredientsInput],
  readonly LineIngredientCandidate[]
> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(
    input: SearchLineIngredientsInput,
  ): Promise<Result<readonly LineIngredientCandidate[], SavedMealError>> {
    return this.repository.searchLineIngredients(input);
  }
}
